import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import { IS_MOBILE, SENTRY_DSN } from '@web/common/config'
import { Router } from 'vue-router'
import { User } from '@web/store/types/modules/user'
import { ignoreErrors } from '@web/common/sentry/ignoreErrors'

type SentryInitOptions = NonNullable<Parameters<typeof Sentry.init>[0]>

export const options: Partial<SentryInitOptions> = {
  dsn: SENTRY_DSN,
  tracesSampleRate: 0.2,
  environment: process.env.NODE_ENV,
  ignoreErrors
}

if (IS_MOBILE) {
  options.release = process.env.VUE_APP_VERSION
}

export function init (app: SentryInitOptions['app'], router: Router) {
  if (SENTRY_DSN) {
    Sentry.init({
      app,
      integrations: [
        new Integrations.BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router)
        })
      ],
      ...options
    })
  }
}

export function sentryConfigure (user: User, username: string): void {
  Sentry.configureScope(scope => {
    const { id, email, ip } = user
    if (id) {
      scope.setUser({
        id: String(id),
        email,
        username,

        ip_address: ip
      })
    }
  })
}

export default Sentry
